<template>
  <v-card class="forgot-card pa-5 pa-sm-7" elevation="8" rounded="xl" aria-labelledby="forgot-password-title">
    <div class="text-center mb-6">
      <v-avatar color="primary" size="52" class="mb-3"><v-icon dark>mdi-lock-reset</v-icon></v-avatar>
      <h1 id="forgot-password-title" class="text-h5 font-weight-bold mb-2">{{ emailSent ? "Check your email" : "Forgot your password?" }}</h1>
      <p class="text-body-2 grey--text mb-0">{{ emailSent ? `If an account exists for ${email}, we sent reset instructions.` : "Enter your account email and we’ll send reset instructions." }}</p>
    </div>
    <v-alert v-if="requestError" type="error" outlined dense role="alert">{{ requestError }}</v-alert>
    <template v-if="emailSent">
      <v-alert type="success" outlined text aria-live="polite">The message may take a few minutes. Check your spam folder if needed.</v-alert>
      <v-alert v-if="resent" type="info" text dense aria-live="polite">Reset instructions were sent again.</v-alert>
      <v-btn block large color="primary" data-cy="forgotPasswordEmailSentBtn" to="/login" :disabled="submitting">Back to login</v-btn>
      <v-btn block text color="primary" class="mt-2" :loading="submitting" :disabled="submitting" @click="sendAgain">Send again</v-btn>
    </template>
    <form v-else novalidate @submit.prevent="submit">
      <v-text-field ref="email" v-model.trim="email" :error-messages="emailErrors" data-cy="forgotPasswordEmail" label="Email address" type="email" autocomplete="email" inputmode="email" outlined color="primary" prepend-inner-icon="mdi-email-outline" :disabled="submitting" @blur="$v.email.$touch()" />
      <v-btn block large color="primary" data-cy="forgotPasswordSendBtn" type="submit" :loading="submitting" :disabled="submitting || !email">Send reset instructions</v-btn>
      <v-btn block text color="primary" class="mt-2" data-cy="forgotPasswordCancelBtn" to="/login" :disabled="submitting">Back to login</v-btn>
    </form>
  </v-card>
</template>
<script>
import authService from "../service";

const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");

export default {
  name: "forget-password",
  mixins: [validationMixin],
  data() {
    return { email: "", emailSent: false, submitting: false, requestError: "", resent: false };
  },
  mounted() { this.$nextTick(() => this.$refs.email && this.$refs.email.focus()); },
  methods: {
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid || this.submitting) return;
      this.submitting = true;
      this.requestError = "";
      this.$Progress.start();
      try {
        await authService.forgetPassword({ email: this.email });
        this.emailSent = true;
        this.$Progress.finish();
      } catch (error) {
        this.$Progress.fail();
        this.requestError = "We couldn’t send reset instructions right now. Please try again.";
      } finally { this.submitting = false; }
    },
    async sendAgain() {
      if (this.submitting) return;
      this.submitting = true;
      this.requestError = "";
      this.resent = false;
      try {
        await authService.forgetPassword({ email: this.email });
        this.resent = true;
      } catch (error) {
        this.requestError = "We couldn’t send reset instructions right now. Please try again.";
      } finally { this.submitting = false; }
    },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.required) errors.push("Email is required.");
      else if (!this.$v.email.email) errors.push("Enter a valid email address.");
      return errors;
    },
  },
  validations: {
    email: {
      email,
      required,
    },
  },
};
</script>
<style scoped>
.forgot-card { width: min(100%, 460px); }
</style>
